/* Copyright 2024 City Trax Limited. All rights reserved. */

import {
    FormField,
    Select
} from '@cloudscape-design/components';
import { useCallback, useEffect, useState } from 'react';
import { get } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth'



function PromptTypeFormField(props) {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState('loading');

    const load = useCallback(async () => {
        try {
            const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
            if (authToken) {
                const restOperation = get({
                    apiName: 'textTuner',
                    path: '/prompts',
                    options: {
                        headers: {
                            Authorization: authToken
                        }
                    },
                });
                const { body } = await restOperation.response;
                const json = await body.json();
                const options_array = (json)
                console.log(json);

                const result_array = []
                // if (props.newTranscription) {
                //     result_array.push({ label: "None", value: "0" })
                // }
                if (options_array.length !== 0) {
                    result_array.push(...options_array.map((item, index) => ({
                        label: item.prompt_type,
                        tags: [item.description],
                        value: (index + 1).toString()
                    })))
                    props.setPromptType(result_array[1])
                } else {
                    props.setPromptType(result_array[0])
                }

                setOptions(result_array)
            }
            setIsLoading('finished')

        } catch (error) {
            console.error(error)
        }

    }, []);

    useEffect(() => {
        load();
    }, [load]);


    return (

        < FormField
            label="Transformation"
            description="Select which type of transformation you would like"
            errorText={props.errorPromptMessage}
        >
            <Select
                selectedOption={props.promptType}
                onChange={({ detail }) => {
                    console.log(detail.selectedOption)
                    props.setPromptType(detail.selectedOption)
                }
                }
                options={options}
                loadingText="Loading prompts"
                statusType={isLoading}

            />
        </FormField >
    )
}

export default PromptTypeFormField;

